import React from 'react';
import {motion} from 'framer-motion';
import {Link} from 'react-router-dom';
import {useCMS} from '../context/CMSContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiArrowRight}=FiIcons;

const Services=()=> {
  const {content}=useCMS();
  const {services}=content;

  const containerVariants={
    hidden: {opacity: 0},
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants={
    hidden: {opacity: 0,y: 20},
    visible: {
      opacity: 1,
      y: 0,
      transition: {duration: 0.8,ease: 'easeOut'},
    },
  };

  return ( 
    <div className="min-h-screen py-20 bg-gray-50"> 
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> 
        <motion.div initial={{opacity: 0,y: 50}} animate={{opacity: 1,y: 0}} className="text-center mb-16" > 
          <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 bg-gradient-to-r from-pink-600 to-green-600 bg-clip-text text-transparent"> 
            {services.title} 
          </h1> 
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed"> 
            {services.subtitle} 
          </p> 
        </motion.div> 

        <motion.div variants={containerVariants} initial="hidden" animate="visible" className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-20" > 
          {services.items.map((service)=> ( 
            <motion.div key={service.id} variants={itemVariants} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all group" whileHover={{y: -10}} > 
              <div className="flex items-start space-x-6"> 
                <div className={`w-20 h-20 ${service.color} rounded-2xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform`} > 
                  <SafeIcon icon={FiIcons[service.icon]} className="w-10 h-10 text-white" /> 
                </div> 
                <div className="flex-1"> 
                  <h3 className="text-2xl font-bold text-gray-900 mb-4"> 
                    {service.title} 
                  </h3> 
                  <p className="text-gray-600 mb-6">{service.description}</p> 
                  <div className="space-y-2 mb-6"> 
                    {service.details.services.slice(0,3).map((item,idx)=> ( 
                      <motion.div key={idx} className="flex items-center space-x-2 text-sm text-gray-600" initial={{opacity: 0,x: -10}} animate={{opacity: 1,x: 0}} transition={{delay: idx * 0.1}} > 
                        <div className="w-2 h-2 bg-pink-500 rounded-full"></div> 
                        <span>{item}</span> 
                      </motion.div> 
                    ))} 
                  </div> 
                  <Link to={`/services/${service.id}`} className="inline-flex items-center bg-gradient-to-r from-pink-600 to-pink-500 text-white px-6 py-3 rounded-lg font-semibold hover:shadow-lg transition-all group-hover:translate-x-2" > 
                    Découvrir ce service 
                    <SafeIcon icon={FiArrowRight} className="ml-2 w-4 h-4" /> 
                  </Link> 
                </div> 
              </div> 
            </motion.div> 
          ))} 
        </motion.div> 

        <motion.div initial={{opacity: 0,y: 50}} animate={{opacity: 1,y: 0}} transition={{delay: 0.6}} className="bg-gradient-to-r from-pink-600 to-blue-600 rounded-2xl p-12 text-white text-center" > 
          <h2 className="text-4xl font-bold mb-6"> 
            Besoin d'une solution personnalisée ? 
          </h2> 
          <p className="text-xl mb-8 max-w-2xl mx-auto"> 
            Nos experts QHSE sont à votre disposition pour analyser vos besoins spécifiques et vous proposer une solution sur mesure. 
          </p> 
          <Link to="/contact" className="inline-block bg-gradient-to-r from-gold-500 to-yellow-400 text-gray-900 px-8 py-4 rounded-lg font-semibold hover:shadow-lg transition-all inline-flex items-center" > 
            Demander une consultation 
            <SafeIcon icon={FiArrowRight} className="ml-2 w-5 h-5" /> 
          </Link> 
        </motion.div> 
      </div> 
    </div> 
  );
};

export default Services;